import { Fragment, memo } from "react";

import { Transition } from "@headlessui/react";

import {
  STOREFRONT_TRANSITION_EASING,
  STOREFRONT_TRANSITION_DURATION,
} from "@tablescape/constants";
import { type CartCloseCartDrawer } from "@tablescape/state";
import { tw } from "classnames";

type Props = {
  closeCartDrawer: CartCloseCartDrawer;
};

const styles = {
  container: tw(
    "absolute",
    "left-0",
    "top-0",
    "h-full",
    "w-full",
    "bg-overlay",
    "overscroll-none"
  ),
  backdrop: {
    enter: tw(
      "transition-opacity",
      STOREFRONT_TRANSITION_EASING,
      STOREFRONT_TRANSITION_DURATION
    ),
    enterFrom: tw("opacity-0"),
    enterTo: tw("opacity-80"),
    leave: tw(
      "transition-opacity",
      STOREFRONT_TRANSITION_EASING,
      STOREFRONT_TRANSITION_DURATION
    ),
    leaveFrom: tw("opacity-80"),
    leaveTo: tw("opacity-0"),
  },
};

const CartDrawerBackdropBase = ({ closeCartDrawer }: Props) => {
  return (
    <Transition.Child
      as={Fragment}
      enter={styles.backdrop.enter}
      enterFrom={styles.backdrop.enterFrom}
      enterTo={styles.backdrop.enterTo}
      leave={styles.backdrop.leave}
      leaveFrom={styles.backdrop.leaveFrom}
      leaveTo={styles.backdrop.leaveTo}
    >
      <div className={styles.container} onClick={closeCartDrawer} />
    </Transition.Child>
  );
};

export const CartDrawerBackdrop = memo(CartDrawerBackdropBase);
